import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import { FilterList, Search } from "@material-ui/icons";

export const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);

  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 200);

  return (
    <span>
      <Input
        value={value || ""}
        placeholder="Search All Columns"
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        startAdornment={
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        }
      />
    </span>
  );
};
